import $ from 'jquery';


let reports = {

  $filters_form : $('#filters-form'),

  init(){
    if( !$('.section.filters').length ){ return; }
    this.toggleSidebar();
    this.changeLayout();
    this.clickFilter();
  },


  changeLayout(){
    $('#layout-map-button').click((e) => {
      e.preventDefault();
      $(e.currentTarget).addClass('active');
      $(e.currentTarget).siblings().removeClass('active');
      $('.layout-map').show();
      $('.layout-list').hide();
    })

    $('#layout-list-button').click((e) => {
      e.preventDefault();
      $(e.currentTarget).addClass('active');
      $(e.currentTarget).siblings().removeClass('active');
      $('.layout-map').hide();
      $('.layout-list').show();
    })
  },

  clickFilter(){
    $('.filter-group__head').click((e) => {
      e.preventDefault();
      $(e.currentTarget).parent().toggleClass('open');
      $(e.currentTarget).parent().find('.filter-group__main').slideToggle();
    })
    // $('.filter-group__main .option input').click((e) => {
    //   $(e.currentTarget).parent().find('label').toggleClass('active');
    // })
    // $('.filter-group__main .btn-all').click((e) => {
    //   e.preventDefault();
    //   $(e.currentTarget).toggleClass('active');
    //   if( $(e.currentTarget).hasClass('active') ){
    //     $(e.currentTarget).parent().find('label').addClass('active');
    //     $(e.currentTarget).parent().find('input').prop('checked', true);
    //   }
    //   else{
    //     $(e.currentTarget).parent().find('label').removeClass('active');
    //     $(e.currentTarget).parent().find('input').prop('checked', false);
    //   }
    // })
    // $('button#reset').click((e) => {
    //   e.preventDefault();
    //   $('#filters-form .btn-all').removeClass('active');
    //   $('#filters-form label').removeClass('active');
    //   $('#filters-form input').prop('checked', false).val('');
    // })
  },

  toggleSidebar(){
    $('.filters__info').click((e) => { 
      $('.map-modal').fadeToggle();
    });
    $('.map-modal__close').click((e) => {  
      $('.map-modal').fadeOut();
    });
    $('.toggle-filters').click((e) => {
      // $(e.currentTarget).hide();
      $(e.currentTarget).toggleClass('open');
      $('.filters .sidebar-left').toggleClass('open');
    })
    $('.filters__close').click((e) => {
      $('.filters .sidebar-left').removeClass('open');
      // $('.toggle-filters').show();
    })
  }


}
export default reports;